import { useState } from "react";
import axios from "axios";

function VendorUploadService() {
  const [formData, setFormData] = useState({
    businessName: "",
    location: "",
    categories: [],
    description: "",
    price: "",
    images: [],
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Handle form input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      setFormData({ ...formData, images: Array.from(files) });
    } else if (name === "categories") {
      const selected = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, categories: selected });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "images") {
          value.forEach((file) => data.append("images", file));
        } else if (Array.isArray(value)) {
          value.forEach((v) => data.append(key, v));
        } else {
          data.append(key, value);
        }
      });

      const token = localStorage.getItem("token"); // assume vendor logged in

      const res = await axios.post("/api/vendor-services", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage(res.data.message || "Service uploaded successfully! Awaiting admin approval.");
      setFormData({
        businessName: "",
        location: "",
        categories: [],
        description: "",
        price: "",
        images: [],
      });
    } catch (err) {
      console.error(err);
      setMessage("Upload failed. Please check your internet connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="vendor-upload-service"
      style={{
        maxWidth: 550,
        margin: "2rem auto",
        background: "#fff",
        padding: "2rem",
        borderRadius: "1rem",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#ff6411", marginBottom: "1.5rem" }}>
        Upload Your Product / Service
      </h2>

      {message && (
        <div
          style={{
            backgroundColor: message.includes("failed") ? "#ffe6e6" : "#e6ffee",
            color: message.includes("failed") ? "#b30000" : "#006600",
            padding: "10px",
            borderRadius: "6px",
            marginBottom: "1rem",
            textAlign: "center",
            fontWeight: 500,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          name="businessName"
          placeholder="Business Name"
          value={formData.businessName}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          name="location"
          placeholder="Location"
          value={formData.location}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <select
          name="categories"
          multiple
          value={formData.categories}
          onChange={handleChange}
          required
          style={inputStyle}
        >
          <option value="solar-panels">Solar Panels</option>
          <option value="inverters">Inverters</option>
          <option value="batteries">Batteries</option>
          <option value="lights">Lights</option>
        </select>

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          required
          rows={4}
          style={{ ...inputStyle, resize: "none" }}
        />

        <input
          type="number"
          name="price"
          placeholder="Price (₦)"
          value={formData.price}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          type="file"
          name="images"
          multiple
          accept="image/*"
          onChange={handleChange}
          style={inputStyle}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            background: loading ? "#aaa" : "#ff6411",
            color: "#fff",
            border: "none",
            padding: "12px",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
            fontWeight: 600,
          }}
        >
          {loading ? "Uploading..." : "Upload Service"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  fontSize: "15px",
  outline: "none",
  transition: "border-color 0.3s",
};

export default VendorUploadService;
